import {ReactNode} from "react";

const CustomRequiredMarkAntdForm = ((label: ReactNode, info: { required: boolean }) => {
    return (
        <>
            <span className={'text-color-2 text-size-3'}>{label}</span>
            {
                info.required &&
                <div className={'text-[#ff4d4f] ml-1'}>*</div>
            }
        </>
    )
})

export default CustomRequiredMarkAntdForm;